module.exports = __webpack_public_path__ + "static/media/bg-header-IUG.553c3209.png";